import { BLOG_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONPOST, basicFILEPOST } from '../helpers/api/fetchParams';

export async function getAllBlogs() {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.API, basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    const sorted = await data.result.sort((a, b) => a.startDate - b.startDate);
    sorted.reverse();
    return sorted;
}

export async function getBlog(id) {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.blog+id, basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function addBlog(body) {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.API+"blog", basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function saveBlog(body) {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.API+"blog", basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function addImage(image, blogId) {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.image+blogId+"/blog", basicFILEPOST(token, image, "POST"));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function deleteImage(blogId) {
    var token = localStorage.getItem("token");
    const response = await fetch(BLOG_URLS.API+"image/"+blogId, basicFILEPOST(token, "", "DELETE"));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceBlogs.js